webpackJsonp([214848477335307],{

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResultsTemplate = __webpack_require__(29);
	
	var _ResultsTemplate2 = _interopRequireDefault(_ResultsTemplate);
	
	var _frontend = __webpack_require__(61);
	
	var _frontend2 = _interopRequireDefault(_frontend);
	
	var _dto = __webpack_require__(9);
	
	var dto = _interopRequireWildcard(_dto);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var experienceData = dto.experience(_frontend2.default.experience);
	var numberOfToolsData = dto.experience(_frontend2.default.numberOfToolsUsed);
	
	var Results = function Results() {
	    return _react2.default.createElement(_ResultsTemplate2.default, {
	        section: 'Front-end',
	        description: 'As always, the battle for JavaScript mindshare is led by front-end frameworks.\n\n*React* is still the dominant player here, but *Vue* is making big gains on the back of\n*Angular*\'s diminishing popularity. By 2018, this chart might end up looking very different!',
	        keys: _frontend2.default.keys,
	        experienceData: experienceData,
	        numberOfToolsData: numberOfToolsData,
	        happiness: _frontend2.default.happiness,
	        sponsor: 'reactforbeginners'
	    });
	};
	
	exports.default = Results;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-2017-front-end-results-js-03b7979b059db96128df.js